import React from 'react'
import s from "./lists.module.css";
import LinkChooser from '../links/linkChooser'

const WithLink = (props) => (props.to ?
  <LinkChooser {...props}>
    {props.children}
  </LinkChooser>
  : <div {...props}>{props.children}</div>
);

const verticalAligment = (aligment) =>{
  if(aligment === 'top'){
    return 'items-start'
  }
  else if(aligment === 'center'){
    return 'items-center'
  }
  else if(aligment === 'bottom'){
    return 'items-end'
  }

}

const List = (props) => (
  <ul
    className={s.container +' '+props.className} style={{'--n-columns':props.columns}}>
      {props.list.map((item,index)=>
        <li
          key={index}
          className={`${item.link ? s.hoverLink : null} ${s.list__item}`}>
          
          <WithLink onClick={item.onClick} to={item.url}>
            <div className={props.layout === 'icon-left' ? `flex ${verticalAligment(props.verticalAligment)}`  : ''}>
              {item.icon ?
                <div className={`${props.iconAlign} ${props.layout === 'icon-left' ? 'pr-3' : 'mb-2'}`}>
                  {typeof item.icon ==='string' ? 
                    <img alt='' src={item.icon} className={s.icon}/> :
                    item.icon
                  }
                </div> :
                null
              }
              <div className={props.textAligment}>
                {item.title ?
                  <p className={`mb-2 c-skyblue-0 b`}>{item.title}</p>
                  : null
                }
                <p className={`mb-1`} >{item.text}</p> 
                {
                  props.linkLabel || props.url ? 
                    <p className='fw-1 c-orange-0'>{props.linkLabel}</p> :
                  null

                }
              </div>
            </div>

          </WithLink>
        </li>
      )}
  </ul>
)

List.defaultProps = {
  layout: '',
  link: false,
  url:'',
  iconAlign: 'center',
  textAligment: 'left',
  verticalAligment: 'top',
  styles: '',
  className:'',
  columns:4,
  linkLabel: false
};

export default List
